/* Zampa d'Oro · scheda prodotto
   Migliora il modulo senza sostituirlo: l'invio resta un normale POST multipart
   verso /cart/add, così la foto arriva davvero a Shopify. */
(() => {
  const root = document.querySelector('[data-zp]');
  if (!root) return;

  const $ = (sel, ctx = root) => ctx.querySelector(sel);
  const $$ = (sel, ctx = root) => Array.from(ctx.querySelectorAll(sel));
  const form = $('[data-zp-form]');
  const maxBytes = Number(root.dataset.maxBytes) || 20 * 1024 * 1024;

  /* Galleria */
  const slides = $$('[data-zp-slide]');
  const thumbs = $$('[data-zp-thumb]');
  const showMedia = (id) => {
    const target = slides.find((s) => s.dataset.zpSlide === String(id));
    if (!target) return;
    slides.forEach((s) => {
      const on = s === target;
      s.classList.toggle('is-active', on);
      if (!on) s.querySelectorAll('video').forEach((v) => v.pause());
    });
    thumbs.forEach((t) => {
      const on = t.dataset.zpThumb === String(id);
      t.classList.toggle('is-active', on);
      if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
  };
  thumbs.forEach((t) => t.addEventListener('click', (e) => {
    e.preventDefault();
    showMedia(t.dataset.zpThumb);
  }));

  /* Varianti */
  const idField = $('[data-zp-id]');
  const submit = $('[data-zp-submit]');
  const submitLabel = $('[data-zp-submit-label]');
  const addText = submitLabel ? submitLabel.textContent.trim() : '';
  const amount = $('[data-zp-amount]');
  const compare = $('[data-zp-compare]');
  const save = $('[data-zp-save]');
  const variantsEl = $('[data-zp-variants]');
  let variants = [];
  try { variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch (err) { variants = []; }

  const setAvailability = (available) => {
    if (!submit) return;
    submit.disabled = !available;
    if (submitLabel) submitLabel.textContent = available ? addText : 'Esaurito';
  };

  const applyVariant = (v) => {
    if (!v) {
      setAvailability(false);
      if (submitLabel) submitLabel.textContent = 'Combinazione non disponibile';
      return;
    }
    if (idField) idField.value = v.id;
    if (amount) amount.textContent = v.price;
    if (compare) { compare.textContent = v.compare || ''; compare.hidden = !v.compare; }
    if (save) { save.textContent = v.save ? `Risparmi ${v.save}` : ''; save.hidden = !v.save; }
    setAvailability(v.available);
    if (v.media) showMedia(v.media);
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    } catch (err) { /* URL non aggiornabile: pazienza */ }
  };

  const optionInputs = $$('[data-zp-option]');
  if (optionInputs.length && variants.length) {
    form.addEventListener('change', (e) => {
      if (!e.target.matches('[data-zp-option]')) return;
      const index = Number(e.target.dataset.zpOption);
      const chosen = $(`[data-zp-chosen="${index}"]`);
      if (chosen) chosen.textContent = e.target.value;
      const selected = [];
      $$('[data-zp-option]:checked').forEach((input) => { selected[Number(input.dataset.zpOption)] = input.value; });
      applyVariant(variants.find((v) => v.options.every((o, i) => o === selected[i])));
    });
  }

  /* Quantità */
  const qty = $('[data-zp-qty]');
  $$('[data-zp-step]').forEach((btn) => btn.addEventListener('click', () => {
    if (!qty) return;
    const next = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(btn.dataset.zpStep));
    qty.value = next;
    qty.dispatchEvent(new Event('change', { bubbles: true }));
  }));

  /* Foto */
  const file = $('[data-zp-file]');
  const drop = $('[data-zp-drop]');
  const fileError = $('[data-zp-file-error]');
  const empty = $('[data-zp-empty]');
  const full = $('[data-zp-full]');
  const preview = $('[data-zp-preview]');
  const fileName = $('[data-zp-filename]');
  const fileSize = $('[data-zp-filesize]');
  const okTypes = ['image/jpeg', 'image/png'];
  const okExt = /\.(jpe?g|png)$/i;

  const formatSize = (bytes) => (bytes >= 1048576 ? `${(bytes / 1048576).toFixed(1).replace('.', ',')} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`);

  const setFileError = (msg) => {
    if (!fileError) return;
    fileError.textContent = msg || '';
    fileError.hidden = !msg;
    if (drop) drop.classList.toggle('is-invalid', Boolean(msg));
    if (file) {
      if (msg) file.setAttribute('aria-invalid', 'true'); else file.removeAttribute('aria-invalid');
    }
  };

  const resetPreview = () => {
    if (empty) empty.hidden = false;
    if (full) full.hidden = true;
    if (preview) preview.removeAttribute('src');
  };

  const checkFile = () => {
    if (!file) return true;
    const f = file.files && file.files[0];
    if (!f) return false;
    const typeOk = okTypes.includes(f.type) || (!f.type && okExt.test(f.name));
    if (!typeOk) {
      const heic = /\.(heic|heif)$/i.test(f.name) || /hei[cf]/i.test(f.type);
      setFileError(heic
        ? 'Le foto HEIC non sono supportate qui. Dall’iPhone sceglila dal rullino con il pulsante qui sopra (di solito diventa JPG da sola), oppure esportala in JPG.'
        : 'Questo file non è una foto JPG o PNG. Scegline un’altra.');
      return false;
    }
    if (f.size > maxBytes) {
      setFileError(`La foto pesa ${formatSize(f.size)}: il massimo è ${formatSize(maxBytes)}. Prova con una versione più leggera.`);
      return false;
    }
    setFileError('');
    return true;
  };

  if (file) {
    file.addEventListener('change', () => {
      const f = file.files && file.files[0];
      if (!f) { resetPreview(); return; }
      if (!checkFile()) {
        file.value = '';
        resetPreview();
        return;
      }
      if (fileName) fileName.textContent = f.name;
      if (fileSize) fileSize.textContent = formatSize(f.size);
      if (empty) empty.hidden = true;
      if (full) full.hidden = false;
      if (preview && 'FileReader' in window) {
        const reader = new FileReader();
        reader.onload = () => { preview.src = reader.result; };
        reader.readAsDataURL(f);
      }
    });
    ['dragenter', 'dragover'].forEach((t) => file.addEventListener(t, () => drop && drop.classList.add('is-over')));
    ['dragleave', 'drop'].forEach((t) => file.addEventListener(t, () => drop && drop.classList.remove('is-over')));
  }

  /* Titolo e nome dalla Nomina: ?titolo=...&nome=... */
  try {
    const params = new URLSearchParams(window.location.search);
    const titolo = $('[data-zp-titolo]');
    const nome = $('[data-zp-nome]');
    const t = params.get('titolo');
    const n = params.get('nome');
    if (titolo && t && !titolo.value) titolo.value = t.slice(0, Number(titolo.maxLength) > 0 ? titolo.maxLength : 60);
    if (nome && n && !nome.value) nome.value = n.slice(0, Number(nome.maxLength) > 0 ? nome.maxLength : 24);
    const medaglia = $('[data-zp-medaglia]');
    if (medaglia && n && !medaglia.value && !titolo) medaglia.value = n.slice(0, Number(medaglia.maxLength) || 12);
  } catch (err) { /* nessun parametro */ }

  /* Nome sulla medaglietta: contatore e nota sul recesso */
  const medaglia = $('[data-zp-medaglia]');
  const count = $('[data-zp-count]');
  const legalMedaglia = $('[data-zp-legal-medaglia]');
  if (medaglia) {
    const sync = () => {
      const left = medaglia.maxLength - medaglia.value.length;
      if (count) count.textContent = medaglia.value ? `Ne restano ${left}.` : '';
      if (legalMedaglia) legalMedaglia.hidden = !medaglia.value.trim();
    };
    medaglia.addEventListener('input', sync);
    sync();
  }

  /* Invio: controlli in italiano, poi lascia partire il POST normale */
  const status = $('[data-zp-status]');
  if (form) {
    form.noValidate = true;
    form.addEventListener('submit', (e) => {
      let firstInvalid = null;

      if (file) {
        const has = file.files && file.files.length > 0;
        if (!has) setFileError('Serve la foto del tuo animale: senza, il pittore non sa chi ritrarre.');
        if (!has || !checkFile()) firstInvalid = firstInvalid || file;
      }

      $$('input[type="checkbox"][required]', form).forEach((box) => {
        if (!box.checked) {
          box.setAttribute('aria-invalid', 'true');
          firstInvalid = firstInvalid || box;
        } else {
          box.removeAttribute('aria-invalid');
        }
      });

      if (qty && (!qty.value || Number(qty.value) < 1)) qty.value = 1;

      if (firstInvalid) {
        e.preventDefault();
        if (status) status.textContent = '';
        const box = firstInvalid === file && drop ? drop : firstInvalid;
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstInvalid.focus({ preventScroll: true });
        return;
      }

      // Non inviare campi facoltativi vuoti né i pulsanti delle varianti (servono solo a scegliere l'id)
      $$('input[name^="properties["]:not([type="file"]):not([type="checkbox"]), [data-zp-option]', form).forEach((input) => {
        if (input.matches('[data-zp-option]') || !input.value.trim()) {
          input.disabled = true;
          input.dataset.zpOff = '1';
        }
      });

      if (submit) {
        // Disabilitare il pulsante dopo che il browser ha letto il modulo, non prima
        window.setTimeout(() => { submit.disabled = true; }, 0);
        submit.classList.add('is-loading');
        if (submitLabel) submitLabel.textContent = file ? 'Carico la foto…' : 'Aggiungo al carrello…';
      }
      if (status && file) status.textContent = 'Stiamo caricando la foto: con una connessione lenta può volerci qualche secondo.';
    });
  }

  // Tornando indietro dal carrello il pulsante deve essere di nuovo usabile
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    $$('[data-zp-off]').forEach((input) => { input.disabled = false; delete input.dataset.zpOff; });
    if (!submit) return;
    submit.classList.remove('is-loading');
    const current = variants.find((v) => idField && String(v.id) === String(idField.value));
    setAvailability(current ? current.available : true);
    if (status) status.textContent = '';
  });
})();
